import { captureChecks } from "../utils/claim_matching"

export function emptyCapturedState() {
  return {
    name: { value: "", matched: false, lastSeen: "" },
    membership: { value: "", matched: false, lastSeen: "" },
    tier: { value: "", matched: false, lastSeen: "" },
    captures: []
  }
}

export function mergeCaptureResult(state, data, application, evidenceLimit, minimumConfidence) {
  if (data?.frame_inconsistent) {
    recordCapture(state, {
      at: new Date().toISOString(),
      frame_inconsistent: true,
      fraud_signals: data.fraud_signals || {},
      reason: data.reason || "",
      extracted: {
        visible_name: "",
        visible_membership_id: "",
        visible_tier: ""
      },
      confidence: Number(data.confidence || 0)
    }, evidenceLimit)
    return false
  }

  const checks = captureChecks(data.extracted || {}, application)
  const threshold = Number(minimumConfidence)
  const confident = Number.isFinite(threshold) && Number(data.confidence || 0) >= threshold
  let merged = false

  ;["name", "membership", "tier"].forEach((key) => {
    const check = checks[key]
    if (check.value) state[key].lastSeen = check.value
    if (confident && check.accepted && !state[key].matched) {
      state[key] = { ...state[key], value: check.value, matched: true }
      merged = true
    }
  })

  if (merged) {
    recordCapture(state, {
      at: new Date().toISOString(),
      reason: data.reason || "",
      extracted: {
        visible_name: checks.name.accepted ? checks.name.value : "",
        visible_membership_id: checks.membership.accepted ? checks.membership.value : "",
        visible_tier: checks.tier.accepted ? checks.tier.value : ""
      },
      confidence: Number(data.confidence || 0)
    }, evidenceLimit)
  }

  return merged
}

function recordCapture(state, row, evidenceLimit) {
  state.captures = [...state.captures, row].slice(-evidenceLimit)
}

export function captureSummaryComplete(state) {
  return state.name.matched && state.membership.matched && state.tier.matched
}

export function captureResultConfirms(data, application, minimumConfidence) {
  if (!data || data.frame_inconsistent) return false

  const threshold = Number(minimumConfidence)
  const confident = Number.isFinite(threshold) && Number(data.confidence || 0) >= threshold
  if (!confident) return false

  const checks = captureChecks(data.extracted || {}, application)
  const visibleChecks = Object.values(checks).filter((check) => check.value)
  return visibleChecks.length > 0 && visibleChecks.every((check) => check.accepted)
}

export function captureProgressReason(state, lastReason = "", labels = {}) {
  if (captureSummaryComplete(state)) return labels.complete || "All required details were captured."

  const missing = []
  if (!state.name.matched) missing.push(labels.name || "full name")
  if (!state.membership.matched) missing.push(labels.membership || "membership number")
  if (!state.tier.matched) missing.push(labels.tier || "current status")
  const missingText = missing.length > 0
    ? (labels.stillNeed || "Still need: %{fields}.").replace("%{fields}", missing.join(", "))
    : ""
  return [missingText, lastReason].filter(Boolean).join(" ")
}
